(function () {
    'use strict';

    angular
        .module('app')
        .factory('CarryoverService', CarryoverService);

    function CarryoverService($http, $q, $rootScope, WebAPIUrl, WebApiService) {
        var service = {
            doPrototypeCarryover: doPrototypeCarryover,
            doPatternCarryover: doPatternCarryover,
            uploadMassCarryoverDocument: uploadMassCarryoverDocument,
            shiftPatternSeason: shiftPatternSeason,
            shiftPrototypeSeason: shiftPrototypeSeason
        };

        return service;

        function doPrototypeCarryover(prototypeData, fromSeasonId, toSeasonId, toLinePlanId) {
            return WebApiService.postJson("/api/Carryover/DoPrototypeCarryover",
                { PrototypeData: prototypeData, ToSeasonId: toSeasonId, ToLinePlanId: toLinePlanId, FromSeasonId: fromSeasonId }
            );
        }

        function doPatternCarryover(patternSeasonalId, toLinePlanId) {
            return WebApiService.postJson("/api/Carryover/DoPatternCarryover",
                { PatternSeasonalId: patternSeasonalId, ToLinePlanId: toLinePlanId }
            );
        }

        function shiftPatternSeason(fromPatternId, fromSeasonId, toSeasonId, toLinePlanId) {
            return WebApiService.postJson("/api/Carryover/ShiftPatternSeason",
                { FromPatternId: fromPatternId, FromSeasonId: fromSeasonId, ToSeasonId: toSeasonId, ToLinePlanId: toLinePlanId }
            );
        }

        function shiftPrototypeSeason(prototypeSeasonalId, linePlanId) {
            return WebApiService.postJson("/api/Carryover/ShiftPrototypeSeason",
                { PrototypeSeasonalId: prototypeSeasonalId, LinePlanId: linePlanId }
            );
        }

        function uploadMassCarryoverDocument(file, toSeasonId, toLinePlanId) {
            var deferred = $q.defer();

            var fd = new FormData();
            fd.append("file1", file);

            $http.post(WebAPIUrl + "/api/Carryover/UploadPrototypeCarryover?toSeasonId=" + toSeasonId + '&toLinePlanId=' + toLinePlanId, fd, {
                transformRequest: angular.identity,
                headers: { 'Content-Type': undefined }
            }).success(function (data, status, headers, cfg) {
                deferred.resolve(data);
            }).error(function (err, status) {
                deferred.reject(err, status);
            });

            return deferred.promise;

        }
    }

})();
